import { render, staticRenderFns } from "./AtividadeListagem.vue?vue&type=template&id=770e32fa&scoped=true&"
import script from "./AtividadeListagem.vue?vue&type=script&lang=js&"
export * from "./AtividadeListagem.vue?vue&type=script&lang=js&"
import style0 from "./AtividadeListagem.vue?vue&type=style&index=0&id=770e32fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770e32fa",
  null
  
)

export default component.exports